import produce from 'immer'
import config from './_config'
import { Account } from './types'
import { useMutation } from '../../internal'
import { Memberships } from '../memberships'
import membershipConfig from '../memberships/_config'

const useUnsubscribe = () => {
  const mutation = useMutation()

  return mutation<Memberships.Membership, Account.Unsubscribe>({
    method: 'GET',
    endpoint: config.endpoints.unsubscribe,
    cacheKey: membershipConfig.cacheKeys.byId(),
    cacheUpdateMode: 'settled',
    cacheUpdater: (snapshot, _) => {
      return produce(snapshot, (draft = {} as Memberships.Membership) => {
        return Object.assign(draft, { wantBeEmails: false })
      })
    }
  })
}

export default useUnsubscribe
